import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, registerables } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { colors } from '../../../theme/colors';
import './InstallationGraph.scss';

ChartJS.register(...registerables);

interface InstallationGraphProps {
  percentage: number;
  title: string;
}

const chartOptions: import('chart.js').ChartOptions<'bar'> = {
  plugins: {
    legend: { display: false },
    tooltip: { enabled: false },
    datalabels: {
      anchor: 'end',
      align: 'end',
      formatter: (value: number) => `${value}%`,
      font: { size: 20, weight: 'normal' },
      color: colors.COLOR_TEXT,
    },
  },
  scales: {
    x: { display: false },
    y: { display: false, max: 100 },
  },
  layout: { padding: { top: 30 } },
  maintainAspectRatio: false,
};

const buildChartData = (value: number): import('chart.js').ChartData<'bar', number[], string> => ({
  labels: [''],
  datasets: [
    {
      data: [value],
      backgroundColor: colors.PRIMARY,
      borderWidth: 0,
    },
  ],
});

const InstallationGraph = ({ percentage, title }: InstallationGraphProps) => {
  return (
    <div className={'GraphicInstallation__div'}>
      <div className={'GraphicInstallation__chart-wrapper'}>
        <Bar data={buildChartData(percentage)} options={chartOptions} plugins={[ChartDataLabels]} />
      </div>
      <p className={'GraphicInstallation__label'}>{title}</p>
    </div>
  );
};

export default InstallationGraph;
